module.exports = __webpack_public_path__ + "img/signature-vertEmeraude.0a3e0063.png";